import { IconButton, Td, Tr } from "@chakra-ui/react";
import { IoPencil, IoTrashBinOutline } from "react-icons/io5";
import { maskValue } from "../forms/JailTextInputWrapper";
import { useContext } from "react";
import { AuthContext } from "@/providers/auth";

const HistoryRecord = ({
  record,
  cells,
  onEdit,
  onDelete,
}: {
  record: any;
  cells: string[];
  onEdit: Function;
  onDelete: Function;
}) => {
  const { userDetails } = useContext(AuthContext);
  const maskData =
    userDetails && userDetails.isJailUser && !userDetails.isJailSso;

  return (
    <Tr key={record.id}>
      {cells.map((cell, index) => (
        <Td key={index + cell}>{maskData ? maskValue(cell) : cell}</Td>
      ))}
      <Td isNumeric>
        <IconButton
          aria-label="Edit Record"
          size="sm"
          variant="ghost"
          onClick={() => onEdit(record.id)}
          icon={<IoPencil />}
        />
        <IconButton
          aria-label="Delete Record"
          size="sm"
          variant="ghost"
          onClick={() => onDelete(record.id)}
          icon={<IoTrashBinOutline />}
        />
      </Td>
    </Tr>
  );
};

export default HistoryRecord;
